import { useEffect, useState } from 'react';

import { SelectOption } from '../../../sharedModules/form/model';
import axios from '../../../sharedModules/utils/axios.utils';
import { fetchWarehouseList, flattenWarehouseOptions } from '../../warehouseOptions/model';
import { toNameChoices, toWarehouseChoices } from './receivingLogFilters';

interface ReceivingLogFilterOptions {
  receivers?: string[];
  departments?: string[];
}

export const useReceivingLogChoices = (location: string) => {
  const [receiverChoices, setReceiverChoices] = useState<SelectOption[]>([]);
  const [departmentChoices, setDepartmentChoices] = useState<SelectOption[]>([]);
  const [warehouseChoices, setWarehouseChoices] = useState<SelectOption[]>([]);

  useEffect(() => {
    const loadChoices = async () => {
      try {
        const response = await axios.get<ReceivingLogFilterOptions>('/warehouse/receiving_logs/filter_options', {
          params: { location },
        });
        setReceiverChoices(toNameChoices(response.data?.receivers));
        setDepartmentChoices(toNameChoices(response.data?.departments));
      } catch {
        setReceiverChoices([]);
        setDepartmentChoices([]);
      }

      try {
        const data = await fetchWarehouseList(location);
        setWarehouseChoices(toWarehouseChoices(flattenWarehouseOptions(data)));
      } catch {
        setWarehouseChoices([]);
      }
    };

    loadChoices();
  }, [location]);

  return { receiverChoices, departmentChoices, warehouseChoices };
};
